"use client";

import { ReactNode } from "react";
import { ServerActionErrorBoundary } from "./ServerActionErrorBoundary";
import { GlobalErrorHandler } from "./GlobalErrorHandler";

interface ClientErrorWrapperProps {
  children: ReactNode;
}

/**
 * Wrapper cliente que combina Error Boundary e Global Error Handler
 * para capturar erros de Server Action e forçar reload automático.
 */
export function ClientErrorWrapper({ children }: ClientErrorWrapperProps) {
  return (
    <ServerActionErrorBoundary>
      <GlobalErrorHandler />
      {children}
    </ServerActionErrorBoundary>
  );
}

export default ClientErrorWrapper;
